import Endpoint from "@/utils/endPoint";

const sensitiveWordsEndpoint = new Endpoint("/sensitive_words/");
const sensitiveWordEndpoint = new Endpoint("/sensitive_words/{id}");
const sensitiveWordPostEndpoint = new Endpoint("/sensitive_words/{id}/posts");
const sensitiveWordAlbumEndpoint = new Endpoint("/sensitive_words/{id}/album_bodies");

class SensitiveWordService {
    async getSensitiveWordListService(params) {
        const result = await sensitiveWordsEndpoint.get(params);
        return result;
    }
    async createSensitiveWordService(params) {
        const result = await sensitiveWordsEndpoint.post(params);
        return result;
    }
    async delSensitiveWordService(params) {
        const result = await sensitiveWordEndpoint.del(null, params);
        return result;
    }
    async getSensitiveWordPostListService(params) {
        const result = await sensitiveWordPostEndpoint.get(params);
        return result;
    }
    async getSensitiveWordAlbumListService(params) {
        const result = await sensitiveWordAlbumEndpoint.get(params);
        return result;
    }
}

export default new SensitiveWordService();
